import { gql } from '@apollo/client';
import { ClientFragment } from '../fragments/ClientFragment';
/**
 * @const UpdateClientMutation
 * @since 1.0.0
 */
export const UpdateClientMutation = gql `
  mutation UpdateClientMutation($input: UpdateClientInput!) {
    updateClient(input: $input) {
      ...ClientFragment
    }
  }

  ${ClientFragment}
`;
